"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionFilterContextProvider = void 0;
var React = require("react");
var editablelist_1 = require("../../interfaces/editablelist");
var urls_1 = require("../../urls");
var initialState = {
    filter: __assign({}, editablelist_1.emptyActionFilter),
};
var ActionFilterContext = React.createContext(__assign(__assign({}, initialState), { fetchData: undefined }));
exports.default = ActionFilterContext;
var ActionFilterContextProvider = (function (_super) {
    __extends(ActionFilterContextProvider, _super);
    function ActionFilterContextProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.state = __assign({}, initialState);
        return _this;
    }
    ActionFilterContextProvider.prototype.componentDidMount = function () {
        this.fetchData();
    };
    ActionFilterContextProvider.prototype.fetchData = function () {
        var self = this;
        return $.ajax({
            url: (0, urls_1.resolve)(urls_1.Urls.action_list_filter_state, this.props.project_id),
            method: "GET",
            contentType: "application/json",
            complete: ajaxErrorHandler,
            success: function (data) {
                self.setState(function (prev) { return ({ filter: data }); });
            }
        });
    };
    ActionFilterContextProvider.prototype.render = function () {
        return (React.createElement(ActionFilterContext.Provider, { value: __assign(__assign({}, this.state), { fetchData: this.fetchData.bind(this) }) }, this.props.children));
    };
    return ActionFilterContextProvider;
}(React.Component));
exports.ActionFilterContextProvider = ActionFilterContextProvider;
